import { compose, withProps } from 'recompose';
import config from '../../../config';
import { withSpinnerOnPromise } from '../../Common/Spinner';
import withTranslationProvider from '../../Common/Translations/withTranslationProvider';
import { getConfigValue } from '../../Common/Providers/ConfigsApi';

let localProps = {};
const COUNTRIES_POSTAL_CODE_VALIDATION = 'countries-postal-code-validation';
const COUNTRIES_WITH_CITIES = 'countries-with-cities';

const validateShippingAddressInfo = async ({ country_code: countryCode, state, city, postcode: postCode }) => {
  const allowedCountriesPostalCodeValidation = await getConfigValue(COUNTRIES_POSTAL_CODE_VALIDATION);
  const allowedCountriesWithCities = await getConfigValue(COUNTRIES_WITH_CITIES);

  let successStatus = { success: true };

  if (allowedCountriesPostalCodeValidation.indexOf(countryCode) > -1 || allowedCountriesWithCities.indexOf(countryCode) > -1) {
    return await callAddressValidationAPI(countryCode, state, city, postCode);
  }

  return successStatus;
};

const callAddressValidationAPI = async (countryCode, state, city, postCode) => {
    let payload = JSON.stringify({
        'countryCode': countryCode,
        'state': state,
        'city': city,
        'postalCode': postCode
    });

    let apiCall = (uri = `${config.shipping}/validate-shipping-address`) => 
        fetch(uri, {
            method: 'POST',
            body: payload,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        });

    try {
        let shippingResponse = await apiCall(); 
        return shippingResponse.json();
    } catch (error) {
        let beResponse = await apiCall(`${config.shippingViaBe}/validate-shipping-address`.replace(':path-name:', 'validate')); 
        return beResponse.json();
    }
};

const withValidateShippingAddress = compose(
    withTranslationProvider,
    withProps(props => localProps = props),
    withSpinnerOnPromise("validateShippingAddress", validateShippingAddressInfo),
);

export { withValidateShippingAddress };



// WEBPACK FOOTER //
// ./src/Checkout/ShippingAndPayment/ValidateShippingAddress.js